export const keyCodes = {
  tab: 9,
  enter: 13,
  esc: 27,
  space: 32,
  up: 38,
  down: 40,
  shift: 16,
};

export const key = (e) => e.which || e.keyCode || 0;

// Credit: https://stackoverflow.com/a/9039885
export const iOS = () =>
  /(iPad|iPhone|iPod)/g.test(navigator.userAgent) ||
  // iPad on iOS 13+ detection
  (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

export const recalculatePageMargin = () => {
  jQuery('.page').css(
    'margin-top',
    (jQuery('.header').height() || 0) +
      (jQuery('.ukhc-alerts').height() || 0) +
      (jQuery('.subnav--subsite .subnav__navbar').height() || 0),
  );
};

export const debounce = (callback, delay) => {
  let timer;

  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      callback.apply(this, args);
    }, delay);
  };
};

jQuery(function ($) {
  $('body').append('<div class="scrollbar-measure"></div>');
});

jQuery.fn.extend({
  interact(callback, opts) {
    if (typeof opts === 'undefined') {
      opts = { blurOnClick: true };
    }

    this.each(function () {
      jQuery(this).on('click keypress', function (e) {
        if (opts.blurOnClick && e.type === 'click') {
          jQuery(this).blur();
        }

        if (e.type === 'click' || [keyCodes.space, keyCodes.enter].includes(key(e))) {
          callback(e);
        }

        return this;
      });
    });

    return this;
  },
});

const fetchDistances = ($locations) => {
  navigator.geolocation.getCurrentPosition((pos) => {
    const origins = [new google.maps.LatLng(pos.coords.latitude, pos.coords.longitude)];
    const destinations = $locations
      .map(function () {
        const latLng = this.value.split(',');

        return new google.maps.LatLng(parseFloat(latLng[0]), parseFloat(latLng[1]));
      })
      .get();

    const service = new google.maps.DistanceMatrixService();
    service.getDistanceMatrix(
      {
        origins,
        destinations,
        travelMode: 'DRIVING',
        unitSystem: google.maps.UnitSystem.IMPERIAL,
      },
      function (response, status) {
        if (status === 'OK') {
          $locations.each(function (idx) {
            const el = jQuery(this);
            const distance = response.rows[0].elements[idx].distance.text.split(' ');
            // distance is now an array of [<value>, <unit>]
            let distanceUnit = '';
            switch (distance[1]) {
              case 'ft':
                if (distance[0] === 1) {
                  distanceUnit = 'foot';
                } else {
                  distanceUnit = 'feet';
                }
                break;
              case 'mi':
                if (distance[0] === 1) {
                  distanceUnit = 'mile';
                } else {
                  distanceUnit = 'miles';
                }
                break;
              default:
                // eslint-disable-next-line prefer-destructuring
                distanceUnit = distance[1];
                break;
            }
            const dist = el.siblings('div');
            if (dist.hasClass('card-summary__distance')) {
              dist.addClass('card-summary__distance--show');
              dist.html(`${distance[0]} ${distanceUnit} Away`);
            } else {
              dist.html(`(${distance[0]} ${distanceUnit})`);
            }
          });
        }
      },
    );
  });
};

const setupObserver = (container, threshold) => {
  if (typeof container === 'undefined') {
    return;
  }

  const $locations = jQuery(
    '.card-summary__card [name="location"], .locations__entry [name="location"]',
    container,
  );

  const observer = new IntersectionObserver(
    (entries) => {
      if (entries[0].intersectionRatio >= threshold) {
        const $entry = jQuery(entries[0].target);
        if (!$entry.data('distances-fetched')) {
          $entry.data('distances-fetched', true);

          // Hit the API
          fetchDistances($locations);
        }
      }
    },
    { threshold },
  );

  observer.observe(container);
};

// Invoked when ukhc/google library is attached
window.calculateDistances = function () {
  if ('geolocation' in navigator) {
    // Related Content
    setupObserver(jQuery('.related_content__col--locations').get(0), 0.75);

    // Profile Detail
    setupObserver(jQuery('.block-views-blockprofiles-block-profile-detail-locations').get(0), 1);
  }
};
